import React from 'react'
import type { BoxBlock as BlockProps } from '@/payload-types'
import { Box } from '@/components/Box'
import { RenderBlocks } from '@/blocks/RenderBlocks'

export const BoxBlock: React.FC<BlockProps> = ({ layout }) => {
  return (
    <Box>
      <RenderBlocks blocks={layout ?? []} />
    </Box>
  )
}
